var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgWavesLanding1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 245,
    viewBox: "0 0 1920 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2082.81 250.926L-19.8634 253.488L-35.6211 11.3201L-34.1414 39.5544C-6.76737 34.5789 20.3354 28.212 47.0615 20.4784C208.966 -26.1529 389.594 19.1698 579.359 66.7835C827.731 129.104 1091.76 195.352 1349.93 64.4918C1570.93 -47.5197 1849.66 6.37425 2082.81 100.463L2082.81 250.926Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWavesLanding1);
export default __webpack_public_path__ + "static/media/bg-waves-landing-1.2a4884d5f2125c6c6e48317f5d88678a.svg";
export { ForwardRef as ReactComponent };